/**
 * Shared layout for /admin/*. Provides a left sidebar (desktop) / top
 * tab bar (mobile) with role-checked navigation links.
 */
import { NavLink, Outlet } from 'react-router-dom';
import {
  Coffee,
  LayoutDashboard,
  ReceiptText,
  Settings,
  Users,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '../../lib/cn';

const NAV_ITEMS: { to: string; label: string; icon: LucideIcon }[] = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/admin/menu', label: 'Menu', icon: Coffee },
  { to: '/admin/orders', label: 'Orders', icon: ReceiptText },
  { to: '/admin/users', label: 'Users', icon: Users },
  { to: '/admin/settings', label: 'Settings', icon: Settings },
];

export function AdminLayout() {
  return (
    <div className="flex flex-col lg:flex-row min-h-[calc(100dvh-60px)]">
      <nav className="lg:w-56 lg:shrink-0 lg:border-r border-wca-gray-light bg-wca-surface">
        <p className="hidden px-4 pt-5 pb-1 font-mono text-[11px] uppercase tracking-[0.18em] text-wca-gray-mid lg:block">
          Admin
        </p>
        <ul className="flex lg:flex-col gap-1 p-3 lg:pt-2 overflow-x-auto">
          {NAV_ITEMS.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.to === '/admin'}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-2.5 whitespace-nowrap rounded-xl px-4 py-2.5 text-sm font-medium min-h-[44px] transition-all',
                    isActive
                      ? 'bg-wca-red text-white shadow-[0_6px_16px_-6px_rgba(196,18,48,0.5)]'
                      : 'text-wca-black hover:bg-wca-gray-light',
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    <item.icon
                      size={16}
                      className={isActive ? 'text-white' : 'text-wca-gray-mid'}
                      aria-hidden="true"
                    />
                    {item.label}
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <main className="flex-1 min-w-0 bg-wca-chalk">
        <Outlet />
      </main>
    </div>
  );
}
